import React, { CSSProperties } from 'react';
import { Text } from '@appsvio/get-started-page';

//@ts-ignore
import gifArcadeDynamicField from '../assets/arcadeDynamicField.gif';
//@ts-ignore
import gifArcadeMultiSelect from '../assets/arcadeMultiSelect.gif';
//@ts-ignore
import gifArcadeRegex from '../assets/arcadeRegex.gif';

import { handleArcadeClick } from './arcadeClickHandler';

const MULTILEVEL_SELECT_ARCADE_URL = 'https://app.arcade.software/flows/dfzJDBkr6OSyenFMlTh7/view';
const REGEX_ARCADE_URL = 'https://app.arcade.software/share/7DGRbZAKWwqsvXl90LVM';
const DYNAMIC_FIELD_ARCADE_URL = 'https://app.arcade.software/share/W3cih1H6JgwjLRMjnqbI';

const MULTILEVEL_SELECT_DOCS_URL = 'https://docs.appsvio.com/multilevel-cascading-select/using-app/configure-custom-field';
const REGEX_DOCS_URL =
    'https://docs.appsvio.com/multilevel-cascading-select/using-app/regex-create-and-configure-regular-expression-custom-field';
const DYNAMIC_FIELD_DOCS_URL =
    'https://docs.appsvio.com/multilevel-cascading-select/using-app/dynamic-custom-field-create-and-configure-a-custom-field';

const WRAPPER_STYLES: CSSProperties = {
    position: 'relative',
    width: '95vw',
};

const IMAGE_STYLES: CSSProperties = {
    width: '85vw',
};

const MULTILEVEL_ARCADE_GIF = () => (
    <div style={WRAPPER_STYLES}>
        <a
            onClick={e => handleArcadeClick(MULTILEVEL_SELECT_ARCADE_URL, e)}
            target='_blank'
            href={MULTILEVEL_SELECT_ARCADE_URL}
        >
            <img
                src={gifArcadeMultiSelect as string}
                alt={'Multilevel Select'}
                style={IMAGE_STYLES}
            />
        </a>
    </div>
);

const REGEX_ARCADE_GIF = () => (
    <div style={WRAPPER_STYLES}>
        <a
            onClick={e => handleArcadeClick(REGEX_ARCADE_URL, e)}
            target='_blank'
            href={REGEX_ARCADE_URL}
        >
            <img
                src={gifArcadeRegex as string}
                alt={'Regular expression'}
                style={IMAGE_STYLES}
            />
        </a>
    </div>
);

const DYNAMIC_FIELD_ARCADE_GIF = () => (
    <div style={WRAPPER_STYLES}>
        <a
            onClick={e => handleArcadeClick(DYNAMIC_FIELD_ARCADE_URL, e)}
            target='_blank'
            href={DYNAMIC_FIELD_ARCADE_URL}
        >
            <img
                src={gifArcadeDynamicField as string}
                alt={'Dynamic field'}
                style={IMAGE_STYLES}
            />
        </a>
    </div>
);

const ARCADES = {
    MULTILEVEL: MULTILEVEL_ARCADE_GIF(),
    REGEX: REGEX_ARCADE_GIF(),
    DYNAMIC_FIELD: DYNAMIC_FIELD_ARCADE_GIF(),
};

export const SECTIONS = [
    {
        standardContentProps: {
            interactiveElement: ARCADES.MULTILEVEL,
            linkName: 'Read detailed documentation',
            linkUrl: MULTILEVEL_SELECT_DOCS_URL,
            name: 'Multilevel Select',
            text: 'Create up to 7 levels cascades. Use it on the portal to create a service catalog or on create issue view.',
        },
    },
    {
        standardContentProps: {
            interactiveElement: ARCADES.REGEX,
            linkName: 'Read detailed documentation',
            linkUrl: REGEX_DOCS_URL,
            name: 'Regular expression',
            text: 'Validate field input from customers or your team members. Ensure that provided values are correct and minimize mistakes.',
        },
    },
    {
        standardContentProps: {
            interactiveElement: ARCADES.DYNAMIC_FIELD,
            linkName: 'Read detailed documentation',
            linkUrl: DYNAMIC_FIELD_DOCS_URL,
            name: 'Dynamic field',
            text: 'This read-only custom field uses other fields within the issue to automatically count the input. Collect more crucial data and make informed decisions.',
        },
    },
    {
        customContent: (
            <Text value='You’re onboarded to use advanced custom fields 🎉 Make the most of Jira and tailor the workflow to meet your requirements.' />
        ),
    },
];
